import { useRecoilState } from 'recoil';
import { useCallback, useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { basketAtom } from '../atoms/Basket';
import { getBasketSummary } from '../utils/Basket';
import {
  getTotalBasketAmount,
  getTotalBasketQuantity,
} from '../utils/BasketSummary';

type UseBasketParams = {
  appliedCoupon?: boolean;
};

export const useBasket = ({ appliedCoupon = false }: UseBasketParams = {}) => {
  const [loading, setLoading] = useState(false);
  const [basket, setBasket] = useRecoilState(basketAtom);

  const refreshBasket = useCallback(() => {
    setLoading(true);
    getBasketSummary(appliedCoupon)
      .then(setBasket)
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  }, [appliedCoupon]);

  useEffect(refreshBasket, [refreshBasket]);

  return {
    basket,
    loading,
    refreshBasket,
    totalAmount: getTotalBasketAmount(basket),
    totalQuantity: getTotalBasketQuantity(basket),
  };
};
